
const Materijal = function(DS) {
    return DS.defineResource({
        name: 'Materijal',
        endpoint: '/materijali'
    });
};

Materijal.$inject = ['DS'];


export {Materijal};



// WEBPACK FOOTER //
// ./app/models/materijal.js